<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <Input type="text" v-model="model.val">
      <span slot="append" v-if="model.variable.unit"><strong>{{ model.variable.unit }}</strong></span>
    </Input>
  </FormItem>
</template>

<script>
export default {
  name: 'float-element',
  data: function () {
    return {
      newVal: this.model.val
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.model.val
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
  }
}
</script>
